import React, { useEffect, useState } from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { FormProvider } from 'context/FormContext';
import { useAuthContext } from 'hooks/useAuthContext';
import { approveWithEngJudgementSchema, addFieldFormTestReview } from 'utils/FieldTestsUtils';
import { useFormContext } from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';

// function to load form as DynamicForm component;
const Form = ({ rowData, status, submit, onCancel }) => {
  // build form schema for Approve Dialog
  const { name } = useAuthContext();
  const fieldTestId = rowData[0] && rowData[0].FieldTestId;
  const approveSchema = approveWithEngJudgementSchema(name, fieldTestId);
  const [defaults, setDefaults] = useState({});
  const formContext = useFormContext();

  // updates schema in formContext, this will trigger the formcontext to build references (domains);
  useEffect(() => {
    let mounted = true;
    !formContext.schema && mounted && formContext.updateSchema(approveSchema);
    return () => { mounted = false }
  }, [formContext, approveSchema]);

  // sets default status if provided to component;
  useEffect(() => {
    let mounted = true;
    function handleDefault() {
      if (status) {
        const defaultStatus = formContext.definitions[formContext.schema.properties.ReviewStatusId.$ref].oneOf.filter(r => r.title === status);
        const id = defaultStatus[0].const;
        mounted && setDefaults({ ReviewStatusId: id });
      };
    }
    formContext.ready && handleDefault();
    return () => { mounted = false }
  }, [formContext.schema, formContext.ready, formContext.definitions, status])

  // submit function for approve dialog form; will eventually perform the crud operation;
  const handleSubmit = async (data, exitForm) => {
    const result = await addFieldFormTestReview(data);
    if (result.success) {
      await exitForm();
    };
    return result;
  };

  return formContext.ready ? withExtension(DynamicForm, {
    schema: approveSchema,
    disabledProperties: status ? [...approveSchema.getDisabled(), "ReviewStatusId"] : approveSchema.getDisabled(),
    cancel: true,
    defaultValues: defaults,
    onSubmit: async (e) => {
      return await handleSubmit(e, submit);
    },
    onCancel,
    definitions: formContext.definitions
  }) : <div style={{ width: 450 }}><SkeletonForm /></div>;
}

const ApproveWJudgementForm = ({ ...props }) => <FormProvider><Form {...props} /></FormProvider>;

export default ApproveWJudgementForm;